import { handleActions } from 'redux-actions';
import {
  InstancesByUsageProps,
  LDAPTestResult,
  LDAPTypeReportProps,
  LeakedCredentialsUsersClientsProps,
  LeakedCredentialsUsersProps,
  NewFrontReportProps,
  PartnersState,
  ProviderTypeReportProps,
  SSOReportProps,
} from './interfaces';
import Types from './types';

const initialState: PartnersState = {
  isLoading: false,
  isLoadingEditPartner: false,
  isLoadingCustom: false,
  partnerDetails: null,
  customDetails: null,
  ldapLoading: false,
  partnerList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  allPartnersList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  selectedCompany: null,
  selectedPartner: null,
  allPartnerServersList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  LDAPTypeReport: {} as LDAPTypeReportProps,
  isLoadingLDAPTypeReport: false,
  newFrontReport: {} as NewFrontReportProps,
  isLoadingNewFrontReport: false,
  SSOReport: {} as SSOReportProps,
  isLoadingSSOReport: false,
  providerTypeReport: {} as ProviderTypeReportProps,
  isLoadingProviderTypeReport: false,
  LDAPTestResult: {} as LDAPTestResult,
  instancesByUsage: {} as InstancesByUsageProps,
  isLoadingInstancesByUsage: false,
  isLoadingLeakedCredentialsUsers: false,
  isLoadingLeakedCredentialsUsersClients: false,
  leakedCredentialsUsers: {} as LeakedCredentialsUsersProps,
  leakedCredentialsUsersClients: {} as LeakedCredentialsUsersClientsProps,
};

export default handleActions(
  {
    [Types.NEW_PARTNER_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.NEW_PARTNER_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.NEW_PARTNER_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.DELETE_PARTNER_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.DELETE_PARTNER_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.DELETE_PARTNER_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.LDAP_TEST_REQUEST]: (state: PartnersState) => ({
      ...state,
      ldapLoading: true,
    }),
    [Types.LDAP_TEST_FULFILLED]: (state: PartnersState, { payload }) => ({
      ...state,
      ldapLoading: false,
      LDAPTestResult: payload,
    }),
    [Types.LDAP_TEST_REJECTED]: (state: PartnersState) => ({
      ...state,
      ldapLoading: false,
    }),

    [Types.EDIT_PARTNER_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.EDIT_PARTNER_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.EDIT_PARTNER_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.EDIT_CUSTOM_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.EDIT_CUSTOM_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.EDIT_CUSTOM_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.DELETE_CUSTOM_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.DELETE_CUSTOM_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.DELETE_CUSTOM_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.SAVE_CUSTOM_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.SAVE_CUSTOM_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.SAVE_CUSTOM_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.REMOVE_IMAGE_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.REMOVE_IMAGE_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.REMOVE_IMAGE_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.PUBLISH_CUSTOM_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.PUBLISH_CUSTOM_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.PUBLISH_CUSTOM_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_PARTNER_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
      partnerDetails: null,
      isLoadingEditPartner: true,
    }),
    [Types.GET_PARTNER_FULFILLED]: (state: PartnersState, { payload }) => ({
      ...state,
      isLoading: false,
      partnerDetails: payload,
      isLoadingEditPartner: false,
    }),
    [Types.GET_PARTNER_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
      partnerDetails: null,
      isLoadingEditPartner: false,
    }),

    [Types.GET_CUSTOM_STATE_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoadingCustom: true,
    }),
    [Types.GET_CUSTOM_STATE_FULFILLED]: (
      state: PartnersState,
      { payload }
    ) => ({
      ...state,
      isLoadingCustom: false,
      customDetails: payload,
    }),
    [Types.GET_CUSTOM_STATE_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoadingCustom: false,
    }),

    [Types.GET_ALL_PARTNERS_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ALL_PARTNERS_FULFILLED]: (
      state: PartnersState,
      { payload }
    ) => ({
      ...state,
      partnerList: payload,
      isLoading: false,
    }),
    [Types.GET_ALL_PARTNERS_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_ALL_PARTNERS_OPERATOR_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ALL_PARTNERS_OPERATOR_FULFILLED]: (
      state: PartnersState,
      { payload }
    ) => ({
      ...state,
      allPartnersList: payload,
      isLoading: false,
    }),
    [Types.GET_ALL_PARTNERS_OPERATOR_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.TOGGLE_BLOCK_PARTNER_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.TOGGLE_BLOCK_PARTNER_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.TOGGLE_BLOCK_PARTNER_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.SET_SELECTED_COMPANY]: (state: PartnersState, { payload }) => ({
      ...state,
      selectedCompany: payload,
    }),
    [Types.SET_SELECTED_PARTNER]: (state: PartnersState, { payload }) => ({
      ...state,
      selectedPartner: payload,
    }),

    [Types.GET_ALL_PARTNER_SERVERS_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ALL_PARTNER_SERVERS_FULFILLED]: (
      state: PartnersState,
      { payload }
    ) => ({
      ...state,
      allPartnerServersList: payload,
      isLoading: false,
    }),
    [Types.GET_ALL_PARTNER_SERVERS_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.START_PARTNER_SERVERS_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.START_PARTNER_SERVERS_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.START_PARTNER_SERVERS_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.STOP_PARTNER_SERVERS_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.STOP_PARTNER_SERVERS_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.STOP_PARTNER_SERVERS_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.PUBLISH_PARTNER_SERVERS_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.PUBLISH_PARTNER_SERVERS_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.PUBLISH_PARTNER_SERVERS_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.CLONE_PARTNER_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.CLONE_PARTNER_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.CLONE_PARTNER_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.CHANGE_AD_PASSWORD_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.CHANGE_AD_PASSWORD_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.CHANGE_AD_PASSWORD_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.GET_LDAP_TYPE_REPORT_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoadingLDAPTypeReport: false,
    }),
    [Types.GET_LDAP_TYPE_REPORT_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoadingLDAPTypeReport: true,
    }),
    [Types.GET_LDAP_TYPE_REPORT_FULFILLED]: (
      state: PartnersState,
      { payload }
    ) => ({
      ...state,
      isLoadingLDAPTypeReport: false,
      LDAPTypeReport: payload,
    }),
    [Types.GET_NEW_FRONT_REPORT_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoadingNewFrontReport: false,
    }),
    [Types.GET_NEW_FRONT_REPORT_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoadingNewFrontReport: true,
    }),
    [Types.GET_NEW_FRONT_REPORT_FULFILLED]: (
      state: PartnersState,
      { payload }
    ) => ({
      ...state,
      isLoadingNewFrontReport: false,
      newFrontReport: payload,
    }),
    [Types.GET_SSO_REPORT_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoadingSSOReport: false,
    }),
    [Types.GET_SSO_REPORT_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoadingSSOReport: true,
    }),
    [Types.GET_SSO_REPORT_FULFILLED]: (state: PartnersState, { payload }) => ({
      ...state,
      isLoadingSSOReport: false,
      SSOReport: payload,
    }),
    [Types.GET_PARTNER_PROVIDER_TYPE_REPORT_REJECTED]: (
      state: PartnersState
    ) => ({
      ...state,
      isLoadingProviderTypeReport: false,
    }),
    [Types.GET_PARTNER_PROVIDER_TYPE_REPORT_REQUEST]: (
      state: PartnersState
    ) => ({
      ...state,
      isLoadingProviderTypeReport: true,
    }),
    [Types.GET_PARTNER_PROVIDER_TYPE_REPORT_FULFILLED]: (
      state: PartnersState,
      { payload }
    ) => ({
      ...state,
      isLoadingProviderTypeReport: false,
      providerTypeReport: payload,
    }),

    [Types.EXPORT_PARTNER_SUMMARY_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.EXPORT_PARTNER_SUMMARY_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.EXPORT_PARTNER_SUMMARY_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.PUBLISH_IMAGE_PARTNER_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.PUBLISH_IMAGE_PARTNER_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.PUBLISH_IMAGE_PARTNER_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.BLOCK_SERVER_PARTNER_ACTIONS_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.BLOCK_SERVER_PARTNER_ACTIONS_FULFILLED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.BLOCK_SERVER_PARTNER_ACTIONS_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.UNBLOCK_SERVER_PARTNER_ACTIONS_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.UNBLOCK_SERVER_PARTNER_ACTIONS_FULFILLED]: (
      state: PartnersState
    ) => ({
      ...state,
      isLoading: false,
    }),
    [Types.UNBLOCK_SERVER_PARTNER_ACTIONS_REJECTED]: (
      state: PartnersState
    ) => ({
      ...state,
      isLoading: false,
    }),
    [Types.GET_INSTANCES_BY_USAGE_FULFILLED]: (
      state: PartnersState,
      { payload }
    ) => ({
      ...state,
      isLoadingInstancesByUsage: false,
      instancesByUsage: payload,
    }),
    [Types.GET_INSTANCES_BY_USAGE_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoadingInstancesByUsage: false,
    }),
    [Types.GET_INSTANCES_BY_USAGE_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoadingInstancesByUsage: true,
    }),

    [Types.GET_LEAKED_CREDENTIAL_USERS_REQUEST]: (state: PartnersState) => ({
      ...state,
      isLoadingLeakedCredentialsUsers: true,
    }),
    [Types.GET_LEAKED_CREDENTIAL_USERS_FULFILLED]: (
      state: PartnersState,
      { payload }
    ) => ({
      ...state,
      isLoadingLeakedCredentialsUsers: false,
      leakedCredentialsUsers: payload,
    }),
    [Types.GET_LEAKED_CREDENTIAL_USERS_REJECTED]: (state: PartnersState) => ({
      ...state,
      isLoadingLeakedCredentialsUsers: false,
    }),
    [Types.GET_LEAKED_CREDENTIAL_USERS_CLIENTS_REQUEST]: (
      state: PartnersState
    ) => ({
      ...state,
      leakedCredentialsUsersClients: {
        count: 0,
        next: '',
        previous: '',
        results: [],
      },
      isLoadingLeakedCredentialsUsersClients: true,
    }),
    [Types.GET_LEAKED_CREDENTIAL_USERS_CLIENTS_FULFILLED]: (
      state: PartnersState,
      { payload }
    ) => ({
      ...state,
      isLoadingLeakedCredentialsUsersClients: false,
      leakedCredentialsUsersClients: payload,
    }),
    [Types.GET_LEAKED_CREDENTIAL_USERS_CLIENTS_REJECTED]: (
      state: PartnersState
    ) => ({
      ...state,
      isLoadingLeakedCredentialsUsersClients: false,
    }),
    [Types.RESET_PASSWORD_LEAKED_CREDENTIALS_REQUEST]: (
      state: PartnersState
    ) => ({
      ...state,
      isLoadingLeakedCredentialsUsersClients: true,
    }),
    [Types.RESET_PASSWORD_LEAKED_CREDENTIALS_FULFILLED]: (
      state: PartnersState
    ) => ({
      ...state,
      isLoadingLeakedCredentialsUsersClients: false,
    }),
    [Types.RESET_PASSWORD_LEAKED_CREDENTIALS_REJECTED]: (
      state: PartnersState
    ) => ({
      ...state,
      isLoadingLeakedCredentialsUsersClients: false,
    }),
  },
  initialState
);
